import styled from 'styled-components';

export const StyledPlayerLevel = styled.div`
  background-color: #2b0f53d9;
  height: 40px;
  position: relative;
  display: flex;
  border-radius: 90px;
  box-shadow: 0px 3px 6px 0px rgba(121, 25, 200, 0.4),
    0px 3px 6px 3px rgba(7, 3, 16, 0.48) inset;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 3px 10px;
  text-transform: uppercase;
  font-weight: 600;

  .image {
    height: 30px;
    object-fit: cover;
  }

  .timer-text {
    font-size: 21px;
    color: white;
    text-shadow: 0px 1.5px 0px #000;
  }
`;
